<template>
  <div id="openSubject">
    <!-- <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/student' }">
          <span style="font-size:14px">学员管理</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/open' }">
          <span style="font-size:14px">{{$route.query.phone?'开课':'批量开课'}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>-->
    <el-form
      style="margin-top:20px;"
      ref="addForm"
      :model="addForm"
      :label-width="formLabelWidth"
      :rules="addFormRules"
    >
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="8">
          <el-form-item label="开通用户" prop="studentGroupId">
            <el-input
              v-if="!$route.query.phone"
              rows="3"
              @blur="getMobiles"
              v-model="addForm.name"
              @keyup.enter.native="getMobiless"
              type="textarea"
              placeholder="请输入学员手机号，以回车键分隔"
            ></el-input>
            <el-input v-if="$route.query.phone" v-model="$route.query.phone" type="input" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="开通商品" prop="studentGroupId">
            <el-button type="primary" @click="openaddFormVisible">开通商品</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="24" :lg="20">
          <el-form-item label class="tabs">
            <el-table
              ref="multipleTable"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              :data="subjectList"
              tooltip-effect="dark"
              style="width: 100%;"
              border
            >
              <el-table-column show-overflow-tooltip prop="readyBuy" width="100" label="状态">
                <template slot-scope="row">
                  <span
                    class="mainColor"
                    :style="row.row.readyBuy==1?'color:rgb(36, 210, 181)':'color: #409EFF;'"
                  >{{row.row.readyBuy==1?"已购买":"未购买"}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right:10px;"
                          width="100%"
                          height="44px"
                          :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span
                        style="color:rgb(36, 210, 181);margin-left:10px;"
                        v-if="row.row.recommend=='1'"
                      >{{"[推荐]"}}</span>
                      <span
                        style="color:rgb(36, 210, 181);margin-left:10px;"
                        v-if="row.row.hot=='1'"
                      >{{"[热门]"}}</span>
                      <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                      <span style="display:block;margin-left:10px;">
                        <span style="color:red">￥{{row.row.price}}</span>
                        <span
                          style="text-decoration:line-through;color:rgb(162,170,188)"
                        >￥{{row.row.originalPrice}}</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="100" prop="agentPrice" label="开通价">
                <template slot-scope="row">
                  <span style="color:red;font-weight:bold">{{row.row.agentPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                <template slot-scope="row">{{row.row.validDay}}天</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="所属科目"
              ></el-table-column>
              <el-table-column show-overflow-tooltip width="60" prop="goodsItemCount" label="内容"></el-table-column>
              <el-table-column prop="createTime" label="操作" width="100">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.readyBuy!=1"
                    @click="deleteList(scope.row)"
                    class="mainColor"
                  >移除</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="已选用户">
            <span style="font-size: 14px;">{{mobiles?mobiles.length:0}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="已选商品">
            <span style="font-size: 14px;">{{readuNums?readuNums:0}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="支付合计">
            <span style="font-size: 14px;color:#FF646B">￥{{amount}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: left;margin-left:80px;">
      <el-button type="primary" @click="addSubject">确 定</el-button>
      <el-button type="cancle" @click="Back">取 消</el-button>
    </div>

    <el-dialog title="添加商品" :visible.sync="addFormVisible" width="60%" left>
      <el-form :label-width="formLabelWidth" style="margin-top: -30px; ">
        <el-row :span="24">
          <el-col :sm="9" :md="9" :lg="9">
            <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="9" :md="9" :lg="9">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="5" :md="5" :lg="5" style="margin-left:10px">
            <el-button type="primary" @click="pageList2">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              ref="multipleTables"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              :data="addFormVisibleList"
              tooltip-effect="dark"
              height="400"
              style="width: 100%;"
              @selection-change="selectionChange"
              border
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right:10px;"
                          width="100%"
                          height="44px"
                          :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span
                        style="color:rgb(36, 210, 181);margin-left:10px;"
                        v-if="row.row.recommend=='1'"
                      >{{"[推荐]"}}</span>
                      <span
                        style="color:rgb(36, 210, 181);margin-left:10px;"
                        v-if="row.row.hot=='1'"
                      >{{"[热门]"}}</span>
                      <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                      <span style="display:block;margin-left:10px;">
                        <span style="color:red">￥{{row.row.price}}</span>
                        <span
                          style="text-decoration:line-through;color:rgb(162,170,188)"
                        >￥{{row.row.originalPrice}}</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="100" prop="agentPrice" label="开通价">
                <template slot-scope="row">
                  <span style="color:red;font-weight:bold">{{row.row.agentPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                <template slot-scope="row">{{row.row.validDay}}天</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="所属科目"
              ></el-table-column>
              <el-table-column show-overflow-tooltip width="60" prop="goodsItemCount" label="内容"></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 30, 40]"
              style="margin-top: 20px;text-align: right;"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      subjectTreeList: [], //科目

      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children"
      },
      addForm: {},
      readuNums: 0,
      goodsName: "",
      formLabelWidth: "80px",
      addFormRules: {},
      loading: false,
      value1: false,
      subjectList: [],
      subjectListAdd: [],
      temporaryList: [],
      mobiles: [],
      goodsIds: [],
      alreadySubjectList: [],
      arrsSelect: [],
      amount: 0,
      addFormVisibleList: [],
      addFormVisible: false,
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: []
      },
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      }
    };
  },
  created() {},
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.pageList();
    if (this.$route.query.phone) {
      this.mobiles.push(this.$route.query.phone);
    }
  },
  methods: {
    closeDialog() {
      console.log(0, this.subjectListAdd);
      this.subjectListAdd.forEach(item => {
        let addSty = true;
        this.subjectList.forEach(items => {
          if (items.id == item.id) {
            addSty = false;
          }
        });
        if (addSty) {
          this.subjectList.push(item);
        }
      });

      this.amount = 0;
      this.readuNums = 0;
      this.subjectList.forEach(e => {
        if (e.readyBuy != 1) {
          this.amount = this.amount + e.agentPrice;
          this.readuNums = this.readuNums + 1;
        }
      });
      this.addFormVisible = false;
    },
    getMobiles() {
      this.mobiles = [];
      let arr = this.addForm.name.split("\n");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach(element => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach(item => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
      console.log("this.mobiles", this.mobiles);
    },
    getMobiless() {
      this.mobiles = [];
      let arr = this.addForm.name.split("\n");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach(element => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach(item => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
      console.log("this.mobiles", this.mobiles);
    },
    deleteList(row) {
      this.subjectList.forEach((item, index) => {
        if (row.id == item.id) {
          this.subjectList.splice(index, 1);
          this.amount = this.amount - item.agentPrice;
          this.$message.success("移除成功");
        }
      });
    },
    Back() {
      this.$router.go(-1);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList2();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList2();
    },
    pageList2() {
      this.loading = true;
      // this.api.goodsInfo
      //   .getGoodsInfoList({ name: this.goodsName })
      //   .then(result => {
      //     this.subjectList.push(result.data[0]);
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.addFormVisibleList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
          this.addFormVisibleList.forEach(item => {
            let sty = true;
            this.subjectList.forEach(items => {
              if (item.id == items.id) {
                sty = false;
              }
            });
            if (!sty) {
              this.arrsSelect.push(item);
            }
          });
        })
        .then(res => {
          let that = this;
          if (this.addFormVisible) {
            that.$nextTick(function() {
              if (that.arrsSelect) {
                that.arrsSelect.forEach((row, index) => {
                  that.$refs.multipleTables.toggleRowSelection(
                    this.addFormVisibleList[index],
                    true
                  );
                });
              }
            });
          }
          that.webLoading2 = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange(val) {
      // this.searchForm.subjectIds = [];
      // val.forEach(item => {
      //   this.searchForm.subjectIds.push(item[2]);
      // });
      if (val) {
        this.searchForm.subjectIds = [];
        val.forEach(item => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    pageList() {
      if (this.$route.query.id) {
        this.api.goodsInfo
          .getStudentBuyGoodsList({ id: this.$route.query.id })
          .then(result => {
            this.loading = false;
            if (result.data) {
              result.data.forEach(item => {
                item.readyBuy = 1;
              });
              this.subjectList = result.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
        this.api.goodsInfo
          .getStudentBuyGoodsList({ id: this.$route.query.id })
          .then(result => {
            this.alreadySubjectList = result.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    selectionChange(val) {
      this.subjectListAdd = val;
    },
    addSubject() {
      this.goodsIds = [];
      console.log(1, this.alreadySubjectList.length);
      console.log(2, this.subjectList.length);
      this.subjectList.forEach(item => {
        let sty = true;
        this.alreadySubjectList.forEach(e => {
          if (e.id == item.id) {
            sty = false;
          }
        });
        if (sty) {
          this.goodsIds.push(item.id);
        }
      });

      if (this.mobiles.length == 0) {
        return this.$message.error("请选择开通用户！！！");
      }
      if (this.goodsIds.length == 0) {
        return this.$message.error("请选择商品！！！");
      }
      this.api
        .buyGoodsBatchByAgentUser({
          mobiles: this.mobiles,
          goodsIds: this.goodsIds,
          agentId: this.loginData.agentId
        })
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.Back();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openaddFormVisible() {
      this.addFormVisible = true;
      this.pageList2();
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    subjectList(val) {
      console.log(val);
    },
    addFormVisible(val) {
      if (!val) {
        this.searchForm = {
          sell: 1,
          name: ""
        };
        this.page = {
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: ""
        };
        this.subjectListAdd = [];
      }
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
#openSubject {
  background: #ffffff;
  padding: 20px;
}
.tabs .el-form-item__content {
  line-height: 22px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/student/open.vue